import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { getAccessTokenSilently, isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const getToken = async () => {
      try {
        if (isAuthenticated) {
          const token = await getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: "openid profile email offline_access"
          });
          setToken(token);
          localStorage.setItem('pbtoken', token);
        }
      } catch (error) {
        console.error('Error getting token', error);
        if (error.error === 'missing_refresh_token') {
          loginWithRedirect();
        }
      }
    };

    getToken();
  }, [getAccessTokenSilently, isAuthenticated, loginWithRedirect]);

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, loginWithRedirect, logout, user, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
